// P5.3 — Settings section field configs extracted from MySettings.jsx.
// One source of truth for the field structure of each non-Account
// section. Keeps MySettings.jsx small as it grows with Profile Data
// Level 3 (the dynamic profile-specific block below the Common block).
//
// Each entry is the `fields` array consumed by SimpleSection. `labelKey`
// is resolved via `t()` at render time. Plain `label` is reserved for
// brand names (Instagram, LinkedIn, ...) that don't need translation.

export const SECTION_FIELDS = {
  calendar: [
    { key: "training_schedule_pref",   labelKey: "settings.fields.training_schedule_pref" },
    { key: "competition_schedule_pref", labelKey: "settings.fields.competition_schedule_pref" },
    { key: "reminder_lead_time_minutes", labelKey: "settings.fields.reminder_lead_time_minutes" },
  ],
  notifications: [
    { key: "email",            labelKey: "settings.fields.notif_email",    kind: "bool" },
    { key: "in_app",           labelKey: "settings.fields.notif_in_app",   kind: "bool" },
    { key: "campaign",         labelKey: "settings.fields.notif_campaign", kind: "bool" },
    { key: "rewards",          labelKey: "settings.fields.notif_rewards",  kind: "bool" },
    { key: "event_reminders",  labelKey: "settings.fields.notif_event",    kind: "bool" },
  ],
  social_links: [
    { key: "instagram", label: "Instagram" },
    { key: "facebook",  label: "Facebook" },
    { key: "twitter_x", label: "X / Twitter" },
    { key: "tiktok",    label: "TikTok" },
    { key: "youtube",   label: "YouTube" },
    { key: "linkedin",  label: "LinkedIn" },
    { key: "website",   label: "Website" },
  ],
  favorites: [
    { key: "sports",      labelKey: "settings.fields.fav_sports",      kind: "csv" },
    { key: "players",     labelKey: "settings.fields.fav_players",     kind: "csv" },
    { key: "tournaments", labelKey: "settings.fields.fav_tournaments", kind: "csv" },
    { key: "clubs",       labelKey: "settings.fields.fav_clubs",       kind: "csv" },
    { key: "brands",      labelKey: "settings.fields.fav_brands",      kind: "csv" },
    { key: "academies",   labelKey: "settings.fields.fav_academies",   kind: "csv" },
  ],
  hobbies: [
    { key: "hobbies",             labelKey: "settings.fields.hob_hobbies",   kind: "csv" },
    { key: "lifestyle_interests", labelKey: "settings.fields.hob_lifestyle", kind: "csv" },
    { key: "education_interests", labelKey: "settings.fields.hob_education", kind: "csv" },
    { key: "health_interests",    labelKey: "settings.fields.hob_health",    kind: "csv" },
    { key: "travel_interests",    labelKey: "settings.fields.hob_travel",    kind: "csv" },
    { key: "content_preferences", labelKey: "settings.fields.hob_content",   kind: "csv" },
  ],
  wishlist_preferences: [
    // Wishlist Preferences v2 (Feb 2026) — structured catalog multi-selects.
    // Replaces the legacy CSV inputs. The `otherKey` field tells the renderer
    // to feed non-catalog typed strings into the sibling `custom_*_other` array.
    { key: "desired_product_categories",   labelKey: "settings.fields.wlp_categories",   kind: "category_multiselect", otherKey: "custom_category_other" },
    { key: "equipment_brands_of_interest", labelKey: "settings.fields.wlp_brands",       kind: "brand_multiselect",    otherKey: "custom_brand_other" },
    { key: "training_needs_summary",       labelKey: "settings.fields.wlp_training",     kind: "textarea" },
    { key: "tournament_needs_summary",     labelKey: "settings.fields.wlp_tournament",   kind: "textarea" },
    { key: "travel_needs_summary",         labelKey: "settings.fields.wlp_travel",       kind: "textarea" },
    { key: "sponsorship_interest",         labelKey: "settings.fields.wlp_sponsor",      kind: "bool" },
    { key: "sponsorship_categories",       labelKey: "settings.fields.wlp_sponsor_cats", kind: "sponsorship_category_multiselect", otherKey: "custom_sponsorship_category_other" },
  ],
  travel: [
    { key: "usual_travel_region",     labelKey: "settings.fields.tr_region" },
    { key: "tournament_travel_freq",  labelKey: "settings.fields.tr_freq" },
    { key: "hotel_category_pref",     labelKey: "settings.fields.tr_hotel" },
    { key: "transport_preferences",   labelKey: "settings.fields.tr_transport", kind: "csv" },
    { key: "travel_support_needs",    labelKey: "settings.fields.tr_support",   kind: "csv" },
  ],
  profile_common: [
    { key: "full_name",         labelKey: "settings.fields.pd_full_name" },
    { key: "phone_whatsapp",    labelKey: "settings.fields.pd_phone" },
    { key: "country",           labelKey: "settings.fields.pd_country" },
    { key: "city",              labelKey: "settings.fields.pd_city" },
    { key: "organization",      labelKey: "settings.fields.pd_org" },
    { key: "role_title",        labelKey: "settings.fields.pd_role" },
    { key: "decision_role",     labelKey: "settings.fields.pd_decision_role" },
    { key: "consent_recontact", labelKey: "settings.fields.pd_consent",   kind: "bool" },
  ],
  // Phase-1 scope §3 — Level 2 segmentation block.
  // Used for CRM, exports, stats, country/sport filters. Drives the
  // new "Datos de segmentación" card under Profile Data, distinct
  // from the Common (Level 1) card above.
  profile_segmentation: [
    { key: "primary_sport",              labelKey: "settings.fields.pd_sport" },
    { key: "level",                      labelKey: "settings.fields.pd_level" },
    { key: "age_group_served",           labelKey: "settings.fields.pd_age_group" },
    { key: "country_market_relevance",   labelKey: "settings.fields.pd_market_relevance", kind: "csv" },
    { key: "organization_type",          labelKey: "settings.fields.pd_org_type" },
    { key: "athletes_or_users_managed",  labelKey: "settings.fields.pd_managed_count" },
    { key: "digital_maturity",           labelKey: "settings.fields.pd_digital_maturity" },
    { key: "current_tools",              labelKey: "settings.fields.pd_current_tools", kind: "csv" },
    { key: "main_objective",             labelKey: "settings.fields.pd_objective", kind: "textarea" },
  ],
};
